import ProgramDay from './entities/program-day';
import ProgramsList from './entities/programs-list';
import ProgramDetails from './entities/program-details';
import ProgramMakeCopy from './entities/program-make-copy';
import ProgramDaySummary from './entities/program-day-summary';
import ProgramDaySchedule from './entities/program-day-schedule';
import ProgramDaySchedules from './entities/program-day-schedules';
import ProgramTypeCategories from './entities/program-type-categories';
import ProgramDaySchedulesReport from './entities/program-day-schedules-report';
import ProgramDaySchedulesSummaryPrediction from './entities/program-day-schedules-summary-prediction';

export default {
  modules: {
    ProgramDay,
    ProgramsList,
    ProgramDetails,
    ProgramMakeCopy,
    ProgramDaySummary,
    ProgramDaySchedule,
    ProgramDaySchedules,
    ProgramTypeCategories,
    ProgramDaySchedulesReport,
    ProgramDaySchedulesSummaryPrediction,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/programs/index.js